import {
  AUTH_LOGOUT,
  SIGNIN_SUCCESS,
  SET_AUTH_REDIRECT_PATH,
  AUTH_NUMBER,
  SINGIN_TYPE2_ONE,
  SEND_CODE_TOW_FACTOR_SUCCESS,
  SINGIN_TYPE2,
  AUTH_VERIFY_MODEL,
  SET_SIGN_UP,
  SET_TOKEN_NULL,
  SAVE_NUMBER_CODE,
  SIGNUP_VERIFY,
  VERIFY_TYPE, USER_DATA,
  SAVE_USERS_FORGET, LOCK_SYSTEM, UNLOCK_SYSTEM, TRANSFER,
  SET_MENU_DRAWER,
} from "Stores/actionTypes";
import { updateObject } from "./utility";
import { readToken } from "Helpers/Token";
import { read } from "Helpers/LocalStorage";

const initialState = {
  isLoggedIn: readToken() !== undefined,
  transfer: read('StypeSwAllow') ? read('StypeSwAllow') : false,
  isLocked: false, 
  verifyType: null,
  verifyData: null,
  numberCode: null,
  userId: null,
  signupType: 1, //type 1 = email   , type 2 = phone
  phone: null,
  userName: null,
  email: null,
  password: null,
  SelectedProvider: null,
  isVerifiedNum: false,
  isVerifyModel: false,
  user: null,
  userData: null,
  usersForget:null,
  signupToken: null,
  FoPaheader: null,
  menuStatus: false,
};

const authNumber = (state, action) => {
  return updateObject(state, {
    numberCode: action.numberCode,
    isVerifiedNum: true,
  });
};

const authVerifyModel = (state, action) => {
  return updateObject(state, {
    userId: action.userId,
    signupType: action.signupType,
    isVerifyModel: true,
  });
};

const setAuthRedirectPath = (state, action) => {
  return updateObject(state, { authRedirectPath: action.path });
};

const SigninType2One = (state, action) => {
  return updateObject(state, {
    userId: action.userId,
    password: action.password,
    SelectedProvider: action.SelectedProvider,
    isSigninType2One: true,
    signupType: action.signupType,
    isSignin: true,
  });
};
const SigninType2 = (state, action) => {
  return updateObject(state, {
    userId: action.userId,
    password: action.password,
    isSigninType2: true,
    isSignin: true,
  });
};
const UpdateSignUp = (state, action) => {
  return updateObject(state, {
    isSignup: action.active,
  });
};
const UpdateToken = (state) => {
  return updateObject(state, {
    isVerifiedNum: false,
    isSigninType2One: false,
  });
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCK_SYSTEM:
      return updateObject(state, { isLocked: true });
    case UNLOCK_SYSTEM:
      return updateObject(state, { isLocked: false });
    case SET_MENU_DRAWER:
      return updateObject(state, { menuStatus: action.status });
    case USER_DATA:
      return updateObject(state, { userData: action.userData });
    case SIGNIN_SUCCESS:
      return updateObject(state, { isLoggedIn: true });
    case VERIFY_TYPE:
      return updateObject(state, {
        userId: action.userId,
        verifyType: action.verifyType,
        verifyData: action.verifyData,
        signupToken: action.signupToken,
        FoPaheader: action.header
      });
    case SET_TOKEN_NULL:
      return UpdateToken(state);
    case SET_SIGN_UP:
      return UpdateSignUp(state, action);
    case AUTH_LOGOUT:
      return initialState;
    case SET_AUTH_REDIRECT_PATH:
      return setAuthRedirectPath(state, action);
    case AUTH_NUMBER:
      return authNumber(state, action);
    case SINGIN_TYPE2_ONE:
      return SigninType2One(state, action);
    case SEND_CODE_TOW_FACTOR_SUCCESS:
      return SigninType2One(state, action);
    case SINGIN_TYPE2:
      return SigninType2(state, action);
    case AUTH_VERIFY_MODEL:
      return authVerifyModel(state, action);
    case SAVE_NUMBER_CODE:
      return updateObject(state, { numberCode: action.numberCode });
    case SAVE_USERS_FORGET:
      return updateObject(state, { usersForget: action.usersForget });
    case TRANSFER:
      return updateObject(state, { transfer: action.transfer });
    case SIGNUP_VERIFY:
      return updateObject(state, {
        userId: action.userId,
        signupType: action.signupType,
        verifyType: "signup",
        token: action.token,
      });
    default:
      return state;
  }
};

export default AuthReducer;
